import React from 'react';
import PropTypes from 'prop-types';
import { Header, Segment } from 'semantic-ui-react';

import RezervacijeAkcijeContent from './RezervacijeAkcijeContent';
import OtkupProdajaContent from './OtkupProdajaContent';
import enums from '../../../utils/Enums';
import localization from '../../../locales/localization';

export default class ProduzeneRezervacijeContent extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Segment>
                    <Header as="h3">{localization.dnevnaEvidencija.produzeneRezervacije}</Header>
                    <RezervacijeAkcijeContent rezervacije={this.props.produzeneRezervacije} />
                </Segment>
                <Segment>
                    <Header as="h3">{localization.dnevnaEvidencija.racun}</Header>
                    <OtkupProdajaContent
                        klijent={this.props.racun.klijent}
                        type={enums.tipTabliceArtikala.RACUN_FIXED}
                        artikli={this.props.racun.skladisniIzlazi.map(si => {
                            return Object.assign({}, si, {
                                sifra: si.sifraArtikla,
                                naziv: si.nazivArtikla,
                                cijena: si.jedCijena,
                                kolicina: this.props.racun.rbrStorniranogRacuna === null ? si.kolicina : -si.kolicina
                            });
                        })}
                    />
                </Segment>
                <Segment>
                    <Header as="h3">{localization.dnevnaEvidencija.otkupniBlokUzRezervaciju}</Header>
                    <OtkupProdajaContent
                        klijent={this.props.otkupniBlok.fizickaOsoba}
                        type={enums.tipTabliceArtikala.OTKUP_FIXED}
                        artikli={this.props.otkupniBlok.skladisniUlazi.map(su => {
                            return Object.assign({}, su, su.predmet, {
                                cijena: su.jedNabavnaCijena
                            });
                        })}
                    />
                </Segment>
            </React.Fragment>
        );
    }
}

ProduzeneRezervacijeContent.propTypes = {
    produzeneRezervacije: PropTypes.array.isRequired,
    otkupniBlok: PropTypes.object.isRequired,
    racun: PropTypes.object.isRequired
};
